export default function archivedReportTypesDirective() {
  return {
    template: require('./report-types.html'),
    controller: 'ArchivedReportTypesController',
    controllerAs: 'archivedReportTypesVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      userId: '@',
      userName: '@',
      reportTypes: '=',
    },
  };
}
